export const setLocalStorageItem = (key: string, value: string): void => {
	// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
	window.localStorage.setItem(key, value);
};

export const getLocalStorageItem = (key: string): string | null => {
	// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
	return window.localStorage.getItem(key);
};
